/**
 * Engine event channel — engine-to-engine state communication only.
 * Never use for UI component signaling — use ComponentEvents for that.
 * Subscribers must filter on target (_name).
 */
export const EngineEvents = {
    /**
     * Root pubsub channel for all engine state events.
     */
    channel: 'OnEngineStateEvent',

    /**
     * Fired by GroupNodeEngine when the user selects an entry.
     * Consumed by TopicGroupEngine to persist activeNodeId + activeEntryId on the group.
     * Target: EngineNames.TopicGroupEngine
     * Payload: OnSelectedEntryData { rk, nid, eid }
     */
    onSelectedEntry: 'OnSelectedEntry',
};
